import { Module } from 'vuex'
import { RootState } from '@/store/store-types'
import { useDefaultHttp } from '@/core/api/defaults'
import { Goal, GoalPayload } from '@/core/models/goal'
import { Stroke, StrokePayload } from '@/core/models/stroke'
import { Language, LanguagePayload } from '@/core/models/language'
import { useLocalizer } from '@/core/localizer'

export interface ITranslations {
    [key: string]: string
}

export interface IEnums {
    [key: string]: {
        [key: string]: string
    }
}

export interface DefaultsPayload {
    goals: GoalPayload[],
    strokes: StrokePayload[],
    languages: LanguagePayload[],
    translations: ITranslations,
    enums: IEnums,
    preferred_locale: string
}

export type Defaults = {
    goals: Goal[],
    strokes: Stroke[],
    languages: Language[],
    translations: ITranslations,
    enums: IEnums,
    preferredLocale: string
}

const state: Defaults = {
    languages: [],
    translations: {},
    enums: {},
    goals: [],
    strokes: [],
    preferredLocale: ''
}

export const defaults: Module<Defaults, RootState> = {
    state,
    mutations: {
        setDefaults: (state: Defaults, payload: DefaultsPayload) => {
            state.goals = payload.goals.map((item: GoalPayload) => new Goal(item))
            state.strokes = payload.strokes.map((item: StrokePayload) => new Stroke(item))
            state.languages = payload.languages.map((item: LanguagePayload) => new Language(item))
            state.translations = payload.translations
            state.enums = payload.enums
            state.preferredLocale = payload.preferred_locale

            useLocalizer().set(state.preferredLocale)
        },
    },
    actions: {
        getDefaults: <T>(context: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useDefaultHttp()
                    .defaults()
                    .then((data: any) => {
                        context.commit('setDefaults', data.data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        defaults: (state: Defaults): Defaults => {
            return state
        },
        goals: (state: Defaults): Goal[] => {
            return state.goals
        },
        strokes: (state: Defaults): Stroke[] => {
            return state.strokes
        },
        languages: (state: Defaults): Language[] => {
            return state.languages
        },
        translations: (state: Defaults): ITranslations => {
            return state.translations
        },
        enums: (state: Defaults): IEnums => {
            return state.enums
        },
        preferredLocale: (state: Defaults): string => {
            return state.preferredLocale
        },
    }
}
